import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AdaptorData } from 'qp-ui-interface';
import { getBrowserDetector, getTizenDeeplink } from 'qp-utility';
import { DataService } from '../../../data.service';
import { StorefrontService } from '../../../storefront/storefront.service';
import { isLoggedIn } from '../../utils/LoginUtils';
import { isAdultProfile } from '../../utils/profileUtils';
import { ConfigService } from '../config/config.service';
import { RoutingService } from '../routing/routing.service';
import { ScreenService } from '../screen/screen.service';
import { TabService } from '../tabs/tab.service';
import { UserStateService } from '../user-state/user-state.service';
import { AdaptedPayload } from './modal/AdaptedPayload';
import { getAdaptedPayload, getSplitedPayload } from './tizenServiceUtils';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable()
export class TizenService {
  constructor(
    private readonly router: Router,
    private readonly storefrontService: StorefrontService,
    private readonly dataService: DataService,
    private readonly tabService: TabService,
    private readonly routingService: RoutingService,
    private readonly configService: ConfigService,
    private readonly userStateService: UserStateService,
    private readonly screenService: ScreenService,
    private readonly localStorage: LocalStorageService
  ) {}

  async checkOperation(): Promise<void> {
    if (getBrowserDetector().isTizen() && !this.dataService.isTizenPreviewShown && this.havePayload()) {
      this.dataService.isTizenPreviewShown = true;
      const payload = getTizenDeeplink();
      const adaptedPayload = payload?.assetId ? getSplitedPayload(payload?.assetId) : getAdaptedPayload(payload);
      if (adaptedPayload && adaptedPayload.contentType && adaptedPayload.resourceId) {
        this.handleDeeplinkRedirect(adaptedPayload);
        this.dataService.isAppLoaded = true;
      } else if (adaptedPayload?.url) {
        this.userStateService.hideSplashScreen();
        this.dataService.isAppLoaded = true;
        this.router.navigate([adaptedPayload.url], { state: { tabId: adaptedPayload.url } });
      }
    }
  }

  havePayload() {
    return !!getTizenDeeplink();
  }

  public handleDeeplinkRedirect(payload: AdaptedPayload) {
    this.screenService.searchlink = '';
    this.dataService.homeTab = '';
    const adultsRating = this.configService.applicationConfig.restrictedRatingsForKids.split(',').map((e) => e.toLowerCase());
    const adaptorData: AdaptorData = {
      resourceType: payload.contentType,
      resourceId: payload.resourceId,
      tabId: this.dataService.activeTab,
      tabName: this.tabService.getCurrentTab()?.name,
    };
    this.storefrontService
      .fetchResourceDetails(adaptorData)
      .then(async (resource) => {
        if (!isLoggedIn(this.localStorage)) {
          if (payload.isPlayable) {
            await this.routingService.navigateDirectoToPlayer(resource);
          } else {
            await this.routingService.navigateToDetails(resource);
          }
          this.userStateService.hideSplashScreen(false);
        } else if (isAdultProfile(this.localStorage)) {
          this.userStateService.hideSplashScreen(false);
          this.userStateService.startLoading();
          if (payload.isPlayable) {
            await this.routingService.navigateDirectoToPlayer(resource);
          } else {
            await this.routingService.navigateToDetails(resource);
          }
          this.userStateService.stopLoading();
        } else {
          // check for kids in users
          if (resource.ratings.find((rating) => adultsRating.includes(rating.v.toLowerCase()))) {
            // is adult content
            if (payload.isPlayable) {
              await this.routingService.navigateToPin(`player/${payload.contentType}/${payload.resourceId}`, true);
            } else {
              await this.routingService.navigateToPin(`${payload.contentType}/${payload.resourceId}`, true);
            }
            this.userStateService.hideSplashScreen();
          } else {
            if (payload.isPlayable) {
              await this.routingService.navigateDirectoToPlayer(resource);
            } else {
              await this.routingService.navigateToDetails(resource);
            }
            this.userStateService.hideSplashScreen();
          }
        }
      })
      .catch(() => {
        this.userStateService.hideSplashScreen();
      });
  }
}
